<template>
  <div class="ui-banner" :class="{ 'theme--dark': $vuetify.theme.dark }">
    <div
      class="ui-banner__container"
      :class="{ 'ui-banner__container--large': large, 'ui-banner__container--small': small }"
    >
      <div class="ui-banner__container__section ui-banner__container__section--left">
        <UiTitle :title="title" large />
        <v-breadcrumbs
          class="ui-banner__container__section__breadcrumb"
          :items="breadcrumbs"
          v-if="breadcrumbs.length > 1"
        >
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item :exact="item.exact" :to="item.to">
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
          <template v-slot:divider>
            <v-icon size="16">{{ icons.mdiChevronRight }}</v-icon>
          </template>
        </v-breadcrumbs>
        <UiSubtitle v-if="subtitle" :subtitle="subtitle" large />
      </div>
      <div class="ui-banner__container__section ui-banner__container__section--right">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
import UiTitle from '@/components/UI/Title.vue'
import UiSubtitle from '@/components/UI/Subtitle.vue'

export default {
  name: 'UiBanner',
  components: {
    UiTitle,
    UiSubtitle,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    breadcrumbs: {
      type: Array,
      required: false,
      default: () => [],
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    icons: {
      mdiChevronRight,
    },
  }),
}
</script>

<style lang="scss">
.ui-banner {
  @apply tw-p-4 sm:tw-px-6;

  border-bottom: 1px solid map-deep-get($material-light, 'banner', 'border');
  background: map-get($material-light, 'banner', 'background');

  &.theme--dark {
    border-bottom: 1px solid rgba(map-deep-get($material-dark, 'banner', 'border'), 0.12);
    background: map-get($material-dark, 'banner', 'background');
  }

  &__container {
    @apply tw-flex tw-items-center tw-justify-between tw-m-auto tw-w-full;

    &--large {
      @apply tw-max-w-3xl;
    }

    &--small {
      @apply tw-max-w-xl;
    }

    &__section {
      &--left {
        flex: 1;
      }

      &__breadcrumb {
        @apply tw-pl-0 #{!important};
      }
    }
  }
}
</style>
